<template>
    <nav>
        <ul class="pagination">
            <li class="page-item" @click="previousPage()" :class="isNotFirstPage ? '' : 'disabled'">
                <a
                    class="page-link text-primary"
                    :class="isNotFirstPage ? 'text-primary' : 'text-muted'"
                >
                    <span>&laquo;</span>
                </a>
            </li>
            <li class="page-item" v-for="p in pagination.last_page">
                <a
                    class="page-link"
                    :class="
                        isCurrentPage(p) ? 'bg-primary text-white font-weight-bold' : 'text-primary'
                    "
                    @click="fetchPage(p)"
                    >{{ p }}</a
                >
            </li>
            <li class="page-item" @click="nextPage()" :class="isNotFirstPage ? '' : 'disabled'">
                <a
                    class="page-link text-primary"
                    :class="isNotLastPage ? 'text-primary' : 'text-muted'"
                >
                    <span>&raquo;</span>
                </a>
            </li>
        </ul>
    </nav>
</template>
<script>
export default {
    name: "Paginator",
    props: ["pagination"],
    computed: {
        isNotFirstPage() {
            return this.pagination.current_page > 1;
        },
        isNotLastPage() {
            return this.pagination.current_page < this.pagination.last_page;
        },
    },
    methods: {
        isCurrentPage(p) {
            return p === this.pagination.current_page;
        },
        previousPage() {
            if (this.isNotFirstPage) {
                this.$emit("fetch", this.pagination.current_page - 1);
            }
        },
        fetchPage(page) {
            this.$emit("fetch", page);
        },
        nextPage() {
            if (this.isNotLastPage) {
                this.$emit("fetch", this.pagination.current_page + 1);
            }
        },
    },
};
</script>
